/*
 * @Author: Tahiti
 * @Date: 2025-12-9
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-9
 * @Description: 灵感相关API接口
 * @FilePath: /weryai-web/api/inspiration.ts
 */
import { http } from '~/utils/request'
import type { PageResponse } from '~/api/creations'

// 灵感页面
export const getInspirationListApi = (params: {
    page: number,
    size: number,
    relateHisId?: string,
    type?: string,
    types?: Array<string>,
    templatedId?: string,
    templateCode?: string,
    userName?: string,
    startTime?: string,
    endTime?: string,
}) => {
    return http.get<PageResponse<any>>('/api/v1/creative/inspiration/page', params)
}

// 点赞
export const changeUserLikeStateApi = (params: {
    ins_id: string,
    like: boolean
}) => {
    return http.post(`/api/v1/auth/creative/inspiration/${params.ins_id}/like?like=${params.like}`)
}

// 详情查询
export const getInspirationDetailApi = (ins_id:string) => {
    return http.get(`/api/v1/auth/creative/inspiration/${ins_id}`)
}

/** 灵感 Feed 排序：HOT-最热 LATEST-最新 */
export type InspirationFeedSortType = 'HOT' | 'LATEST'

export type InspirationFeedCategory = 'VIDEO' | 'IMAGE'

export interface InspirationFeedItem {
    ins_id: string
    relate_his_id?: number
    type: string
    category?: InspirationFeedCategory
    user?: { user_name?: string; avatar?: string }
    param?: {
        template_id?: number
        template_path?: string
        [key: string]: unknown
    }
    likes_num?: number
    has_like?: boolean
    output?: string
    output_with_watermark?: string
    create_time?: number
    status?: string
    [key: string]: unknown
}

/** 接口返回的 data 字段 */
export interface InspirationFeedResponse {
    content: InspirationFeedItem[]
    has_more: boolean
    next_cursor: string
}

/** 首页灵感列表：feed_card 接口，分页 size 建议 20 */
export const getInspirationFeedApi = (params: {
    sortType: InspirationFeedSortType
    cursor?: string
    size: number
}) => {
    return http.get<InspirationFeedResponse>(
        '/api/v1/creative/inspiration/feed_card',
        params as Record<string, unknown>
    )
}